// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT } from './constants/token.service.constants';
// Types
import { TokenApiDataApiResponseType } from '../types/token-api-data-api-response.type';

const fetchCustomerAuthorizationDataService = async (
  token: string
): Promise<[TokenApiDataApiResponseType, Response]> =>
  apiUtils.get({
    ...ONBOARDING_ACCESS_AUTHORIZATION_ENDPOINT,
    customHeaders: { accessToken: token },
  });

export { fetchCustomerAuthorizationDataService };
